import { useState } from 'react';

function ContactPage() {
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();
    setSent(false);
    setError('');
    setSending(true);

    const form = event.currentTarget;
    const formData = new FormData(form);
    formData.append('_subject', 'Nuevo mensaje desde krystalsoftware.com');
    formData.append('_captcha', 'false');
    formData.append('_template', 'table');

    try {
      const response = await fetch('https://formsubmit.co/ajax/contacto@krystalsoftware.com', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });

      if (!response.ok) {
        throw new Error('No se pudo enviar el mensaje.');
      }

      form.reset();
      setSent(true);
    } catch (submitError) {
      setError('No pudimos enviar tu mensaje. Intenta nuevamente en unos minutos.');
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="mx-auto max-w-7xl px-4 pb-24 pt-12 md:px-8">
      <header className="mb-14">
        <p className="text-xs font-bold uppercase tracking-widest text-primary">Contacto</p>
        <h1 className="mt-4 max-w-3xl text-4xl font-extrabold leading-tight tracking-tight md:text-6xl">
          Hablemos de su próximo gran proyecto.
        </h1>
      </header>

      <div className="grid gap-8 lg:grid-cols-12">
        <section className="rounded-2xl border border-outlineVariant/30 bg-white p-7 shadow-sm lg:col-span-7 md:p-10">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="grid gap-5 md:grid-cols-2">
              <div>
                <label className="mb-2 block text-xs font-bold uppercase tracking-widest text-onSurfaceVariant" htmlFor="name">
                  Nombre
                </label>
                <input
                  id="name"
                  name="nombre"
                  className="w-full rounded-lg bg-surfaceContainerLow px-4 py-3"
                  placeholder="Tu nombre"
                  required
                />
              </div>
              <div>
                <label className="mb-2 block text-xs font-bold uppercase tracking-widest text-onSurfaceVariant" htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  className="w-full rounded-lg bg-surfaceContainerLow px-4 py-3"
                  placeholder="tu@empresa.com"
                  required
                />
              </div>
            </div>

            <div>
              <label className="mb-2 block text-xs font-bold uppercase tracking-widest text-onSurfaceVariant" htmlFor="subject">
                Asunto
              </label>
              <input
                id="subject"
                name="asunto"
                className="w-full rounded-lg bg-surfaceContainerLow px-4 py-3"
                placeholder="¿En qué podemos ayudarte?"
                required
              />
            </div>

            <div>
              <label className="mb-2 block text-xs font-bold uppercase tracking-widest text-onSurfaceVariant" htmlFor="message">
                Mensaje
              </label>
              <textarea
                id="message"
                name="mensaje"
                rows="5"
                className="w-full rounded-lg bg-surfaceContainerLow px-4 py-3"
                placeholder="Cuéntanos sobre tu objetivo y tiempos"
                required
              />
            </div>

            <input type="text" name="_honey" className="hidden" tabIndex="-1" autoComplete="off" />

            <button
              type="submit"
              disabled={sending}
              className="w-full rounded-lg bg-primary px-7 py-4 font-bold text-white shadow-lg shadow-primary/30 disabled:cursor-not-allowed disabled:opacity-70"
            >
              {sending ? 'Enviando...' : 'Enviar mensaje'}
            </button>

            {sent && <p className="text-sm font-semibold text-primary">Mensaje enviado. Te responderemos en menos de 24 horas.</p>}
            {error && <p className="text-sm font-semibold text-red-600">{error}</p>}
          </form>
        </section>

        <aside className="space-y-6 lg:col-span-5">
          <article className="rounded-2xl bg-surfaceContainerLow p-8">
            <div className="mb-5 flex items-start gap-4">
              <span className="material-symbols-outlined text-primary">location_on</span>
              <div>
                <p className="text-xl font-bold">Nuestra sede</p>
                <p className="text-onSurfaceVariant">
                  Lima, Perú
                  <br />
                  Modalidad híbrida para proyectos LATAM y globales.
                </p>
              </div>
            </div>
            <div className="h-48 w-full overflow-hidden rounded-xl">
              <iframe
                title="Mapa de Lima, Perú"
                src="https://www.google.com/maps?q=-12.0464,-77.0428&z=12&output=embed"
                className="h-full w-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{ border: 0 }}
                allowFullScreen
              />
            </div>
          </article>

          <article className="rounded-2xl bg-surfaceContainer p-8">
            <div className="mb-5 flex gap-4">
              <span className="material-symbols-outlined text-primary">call</span>
              <div>
                <p className="text-xs font-bold uppercase tracking-widest text-onSurfaceVariant">Teléfono</p>
                <p className="text-xl font-bold">+51 992 242 237</p>
              </div>
            </div>
            <div className="flex gap-4">
              <span className="material-symbols-outlined text-primary">schedule</span>
              <div>
                <p className="text-xs font-bold uppercase tracking-widest text-onSurfaceVariant">Horario</p>
                <p>Lun - Vie: 09:00 a 18:00</p>
              </div>
            </div>
          </article>
        </aside>
      </div>

      <section className="mt-14 grid gap-6 md:grid-cols-3">
        <article className="rounded-xl bg-surfaceContainerLow p-6">
          <span className="material-symbols-outlined text-primary">verified_user</span>
          <h3 className="mt-3 text-lg font-bold">Soporte prioritario</h3>
          <p className="mt-2 text-sm text-onSurfaceVariant">Respondemos consultas de nuevos proyectos en menos de 24 horas.</p>
        </article>
        <article className="rounded-xl bg-surfaceContainerLow p-6">
          <span className="material-symbols-outlined text-primary">handshake</span>
          <h3 className="mt-3 text-lg font-bold">Consultoría gratuita</h3>
          <p className="mt-2 text-sm text-onSurfaceVariant">Diagnóstico inicial de 15 minutos para alinear alcance y prioridades.</p>
        </article>
        <article className="rounded-xl bg-surfaceContainerLow p-6">
          <span className="material-symbols-outlined text-primary">encrypted</span>
          <h3 className="mt-3 text-lg font-bold">Privacidad total</h3>
          <p className="mt-2 text-sm text-onSurfaceVariant">Tus datos y conversaciones se gestionan con estándares enterprise.</p>
        </article>
      </section>
    </div>
  );
}

export default ContactPage;
